import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { getResourceVentilationString } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import {
    InscriptionT,
    getBudgetProposalFromInscription,
} from 'routes/BudgetModule/shared/entities/inscription';

// Helper to decide what ventilation to display in wandering inscription alert
export const getWanderingInscriptionVentilation = (
    wanderingInscriptions: InscriptionT[],
    budgetProposals: BudgetProposalT[],
    t: TranslationT,
): string => {
    const inscriptionsBudgetProposals = wanderingInscriptions.map((ins) =>
        getBudgetProposalFromInscription(ins, budgetProposals),
    );
    return getResourceVentilationString(inscriptionsBudgetProposals, t);
};
